import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '@core/services/auth/auth.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormErrorMessageComponent } from "../../../shared/components/form-error-message/form-error-message.component";

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ButtonModule,
    InputTextModule,
    FormErrorMessageComponent
],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  @Output() updateisForgotPasswordEvent = new EventEmitter<boolean>();

  forgotPasswordForm : FormGroup<any> = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  })
  isEmailSubmitted : boolean = false;
  submitMessage : string = '';
  isSubmitting: boolean = false;

  constructor(
    protected authService: AuthService,
    private messageService : MessageService
  ) { }

  handleForgotPassword() {
    this.updateisForgotPasswordEvent.emit(false);
  }

  onSubmit() {
    if(this.forgotPasswordForm.valid) {
      this.isSubmitting = true;
      this.authService.forgotPassword(this.forgotPasswordForm.value).subscribe({
        next : (res: any) => {
          this.isSubmitting = false;
          this.isEmailSubmitted = true;
          this.submitMessage = res.message;
        },
        error: (err) => {
          this.isSubmitting = false;
          this.messageService.add({severity:'warn', summary:'Warning', detail: err.error.message || 'Something went wrong', key:'tr'});
          console.error(err);
        }
      })
    } else {
      this.forgotPasswordForm.markAllAsTouched();
    }
  }

}
